<template>
  <!-- eslint-disable max-len -->
  <v-card class="pa-8" style="position: relative;">
    <div>
      <h2 class="text-center">智慧機械雲平台服務條款</h2>
      <p class="my-8">
        智慧機械雲平台(以下簡稱「本平台」)係財團法人工業技術研究院(以下簡稱「工研院」)執行經濟部計畫所設置，在使用「本平台」之前，請您詳細閱讀、了解並同意「智慧機械雲平台服務條款」(以下簡稱「本服務條款」)，如果您不同意本服務條款的內容，或者您所屬的國家或地域排除本服務條款內容之全部或一部時，您應立即停止使用「本平台」及「本平台」服務。當您使用或繼續使用「本平台」時，即視為您已閱讀、瞭解並同意接受本服務條款之所有內容及其後之修改變更。
      </p>
      <p class="mt-1 mb-8 font-weight-bold text-decoration-underline">
        除非「本平台」有另行公告，否則「本平台」將於經濟部計畫執行完畢或經濟部通知計畫停止執行時，即行關閉並停止服務。
      </p>
      <h3>壹、免責聲明</h3>
      <p class="mt-1 mb-8">
        一、「本平台」因事實上無法就平台上所有之資料或服務進行有無侵權之審查，故不保證所提供之資料或服務絕無侵害他人權利之可能；「本平台」亦未就其正確性、時效性、適用性及可靠性為任何表述或判斷。「本平台」上所有之資料或服務都是依「現況」及「現有」基礎提供，「本平台」明確宣告不作任何明示或默示之擔保（保證），其中包括但不限於商業適售性、特定目的之適用性及未侵害他人權利。您應自行承擔因使用「本平台」資料或服務或「本平台」關閉可能產生之任何損害或損失。
      </p>
      <p class="mt-1 mb-8">
        二、「本平台」所提供的任何資料或服務僅作參考用途，並不構成對您任何形式之建議。「本平台」僅提供您在「本平台」進行APP 應用產品 (以下簡稱「產品」)之買賣及「產品」之下載服務。工研院或「本平台」並非「產品」之買方或賣方。工研院或「本平台」不會對您透過「本平台」購買或販售之「產品」提供任何瑕疵擔保或保固責任。「產品」之使用規範、瑕疵擔保責任、保固責任等所有買賣雙方之權利義務，均由買賣雙方約定，與工研院或「本平台」無涉。
      </p>
      <p class="mt-1 mb-8">
        三、「產品」買賣之收費、開立發票、退貨/退費、第三方金流公司服務內容及報酬、「產品」帳務與金流等由「本平台」指定之第三方金流公司負責製訂。您需自行閱讀「本平台」公告之第三方金流公司製訂之相關規範與規定。您一旦在「本平台」進行「產品」之買賣，代表您同意並接受上述規範與規定。
      </p>
      <p class="mt-1 mb-8">
        四、「本平台」有權隨時進行以下事項，恕不另行通知：<br>
        (一)基於任何理由而修改、暫停或終止「本平台」服務或其任何部分之運作或存取。<br>
        (二)修改或變更「本平台」服務或其任何部分以及相關政策或條款。<br>
        (三)在必要情況下中斷「本平台」服務或其任何部分之運作，以利進行定期或非定期維護、錯誤更正或其他變更。
      </p>
      <p class="mt-1 mb-8">
        五、「本平台」可能會提供連結至第三方網站或網路資源的連結，您可能會因此連結至其他業者經營的網站，但不表示「本平台」與該等業者有任何關係。其他業者經營的網站均由各該業者自行負責，不屬「本平台」控制及負責範圍之內。對於任何與「本平台」連結的第三方網站所提供之服務內容，包括檔案、軟體、內容、音樂、圖像或其他任何格式之數位資料，「本平台」並不負任何檢查其真偽，授權與否等責任，「本平台」僅善意引用及介紹，請您知悉並同意，「本平台」無權利與義務，對第三方網站所提供服務之相關內容進行修訂、拒絕或刪除。在您使用第三方所提供之服務內容時，有可能會接觸到使您感覺到冒犯、反感或不悅、粗俗之內容，您必須自行承擔這些相關之風險。
      </p>
      <h3>貳、智慧財產權保護政策</h3>
      <p class="mt-1 mb-8">
        一、「本平台」尊重他人智慧財產權，您不得有任何侵害著作權或其他智慧智慧財產權之行為。經權利人通知您涉有侵權行為後，「本平台」將進行所有停止侵權之處置。
      </p>
      <p class="mt-1 mb-8">
        二、如您涉有侵權情事，「本平台」得終止全部或部分服務。
      </p>
      <p class="mt-1 mb-8">
        三、若您認為「本平台」之任何內容已侵害您的智慧財產權，或您係該智慧財產權人之授權人或代理人，您可將下述事項以郵寄、傳真或電子郵件方式，透過以下聯絡窗口通知「本平台」：<br>
        (一)通知應載明事項
        <ol>
          <li>
            權利人或其代理人之姓名或名稱、地址及聯絡電話、傳真號碼、電子郵件信箱或其他聯繫方式。如為個人，請簽名或蓋章；如為公司行號，請加蓋大小章。以電子郵件信箱檢舉者，請將前述事項載於書面，並將該書面掃描為電子檔後，作為電子郵件之附件傳送予「本平台」，此檢舉方式不接受電子簽章。
          </li>
          <li>
            被侵害之智慧財產權內容之名稱。
          </li>
          <li>
            請求「本平台」將涉有侵害智慧財產權之內容移除或使他人無法進入之聲明。
          </li>
          <li>
            足使「本平台」知悉該涉有侵權內容之相關資訊及其存取路徑。
          </li>
          <li>
            權利人表示其係基於善意，相信涉有侵權內容係未經合法授權或違反智慧財產權相關規定之陳述。
          </li>
          <li>
            註明如有不實致他人受損害者，權利人願負法律責任之聲明。
          </li>
        </ol>
        (二)您的通知不符合上述格式者，「本平台」將通知補正；您未於通知期限內補正者，視為未提出通知。<br>
        (三)聯絡窗口：
        <ol>
          <li>
            姓名/名稱：王培寧
          </li>
          <li>
            聯絡電話：049-2345658
          </li>
          <li>
            傳真號碼：049-2345301
          </li>
          <li>
            電子郵件信箱：PNWang@itri.org.tw
          </li>
          <li>
            地址: 540219南投縣南投市文獻路2號B204室
          </li>
        </ol>
      </p>
      <h3>參、個人資料的蒐集、處理及利用方式</h3>
      <p class="mt-1 mb-8">
        一、「本平台」係因工研院執行經濟部計畫所設置，工研院為提供「本平台」服務而需蒐集、處理及利用您的個人資料（以下簡稱「個資」），謹先告知下列事項：<br>
        (一)蒐集目的：工研院為提供您「本平台」上之資料或服務或執行經濟部計畫所需。<br>
        (二)個資類別：包括但不限於姓名、電子郵件、住家電話號碼、行動電話、住址、金融機構帳戶之號碼與姓名、信用卡或簽帳卡之號碼等。<br>
        (三)利用期間：至蒐集目的消失為止。<br>
        (四)利用地區：中華民國境內。<br>
        (五)利用者：工研院、經濟部及工研院指定之第三方金流機構。<br>
        (六)利用方式：：在不違反蒐集目的的前提下，以網際網路、電子郵件、書面、傳真及其他合法方式利用之。
      </p>
      <p class="mt-1 mb-8">
        二、您得以書面主張下列權利：<br>
        (一)查詢或請求閱覽。<br>
        (二)請求製給複製本。<br>
        (三)請求補充或更正。<br>
        (四)請求停止蒐集、處理或利用。<br>
        (五)請求刪除。<br>
        若有上述需求，請與承辦人員(電話：049-2345658；E-mail：PNWang@itri.org.tw)聯繫，工研院將依法進行回覆。
      </p>
      <p class="mt-1 mb-8">
        三、您若不同意上揭個資蒐集及利用條款，「本平台」可能無法對您提供完整的服務，亦可能無法維護您的權益。
      </p>
      <h3>肆、帳號、密碼與安全性</h3>
      <p class="mt-1 mb-8">
        您應妥善保管您的帳號與密碼，如有未經授權者使用您的帳號或密碼，或發現其他安全漏洞，您應立即通知並尋求「本平台」之協助，以防止任何可能之損害擴大。「本平台」並得採取適當處置或視情況停止您繼續使用「本平台」。
      </p>
      <h3>伍、金流條款/交易條款(含退貨/退款機制)</h3>
      <p class="mt-1 mb-8">
        無論您是「本平台」服務之買方(消費者)或賣方(即「本平台」店家)，一旦您在「本平台」進行交易，即表示您接受並同意以下金流及交易相關條款：
        一、「本平台」服務之金流由紅陽科技股份有限公司(以下簡稱「紅陽」)提供，其服務內容及條件如下：<br>
        (一)支付工具：「本平台」交易限用信用卡付款。<br>
        (二)「紅陽」將向「本平台」店家收取「紅陽」服務費並代收「本平台」服務費。<br>
        (三)收費方式：「紅陽」撥款予「本平台」店家時內扣。<br>
        (四)支付流程： 信用卡：消費者至「本平台」店家網頁選購商品→消費者輸入信用卡付款資訊→取得消費者發卡銀行之授權碼→成功授權→收單銀行撥款至「紅陽」與信託銀行簽訂信託契約所約定之信託專戶→交易完成後依約定時程，由「紅陽」指示信託銀行整批匯款至「本平台」店家指定戶頭。<br>
        (五)付帳戶款項提領方式：依「本平台」店家與「紅陽」簽訂契約之約定期間（如上述支付流程內說明），由「紅陽」主動指示信託銀行辦理匯撥。<br>
        (六)「本平台」店家與「紅陽」將另簽訂金流服務契約，規範雙方權利義務。<br>
      </p>
      <p class="mt-1 mb-8">
        二、匯率之計算<br>
        「本平台」服務所有交易帳款均應以新臺幣計價結付，不涉及匯率換算。若消費者以國外信用卡刷卡結帳，則依發卡銀行以結帳日當天的匯率為準，至於發卡銀行如何換算匯率，由持卡者與發卡銀行聯繫。
      </p>
      <p class="mt-1 mb-8">
        三、繳費金額限制<br>
        信用卡：單筆金額限制一百萬以內。
      </p>
      <p class="mt-1 mb-8">
        四、發票機制<br>
        (一)消費者於消費時可選擇存入電子發票手機條碼，做為「本平台」店家後續開立發票之依據。<br>
        (二)考量系統維護一致性，建議「本平台」店家使用「紅陽」發票服務。若「本平台」店家希望自行開立發票，「本平台」亦提供消費者所留存之手機條碼等資訊做為開立發票之依據。<br>
        (三)「本平台」店家於上線前須自行向「紅陽」申請開通發票服務，後續透過「本平台」與「紅陽」串接之電子發票系統，由「紅陽」端協助開立電子發票，相關服務衍伸之合約內容「本平台」店家須自行與「紅陽」洽詢。「紅陽」發票服務可參考網址：https://inv.sunpay.com.tw/。<br>
        (四)「紅陽」亦提供協助開立紙本發票的服務，「本平台」店家若有此需求，須自行與「紅陽」洽詢。
      </p>
      <p class="mt-1 mb-8">
        五、帳單付款規則<br>
        (一)帳單採月結制，消費者將統一在每個月 1 號收到繳費通知，提醒繳交上一期費用，並給予寬限期 15 日。若消費者仍未繳款，則於當月 8 號和 15 號將再收到提醒繳款通知，當月 16 號該消費者之使用者帳號將被標示為警示用戶。<br>
        (二)消費者如被標記為警示用戶，在其完成繳交款項前，將每日收到繳款通知。<br>
        (三)「本平台」店家將於消費者啟動「產品」時，發動「查詢警示狀態 API」，若回傳的狀態標示為警示用戶，則該店家可決定後續停權機制。<br>
        (四)若消費者超過寬限期仍未繳款，則該消費者帳號將被標示為警示用戶，並收到繳費通知。<br>
        (五)若消費者已繳交費用，則其帳號的警示狀態將被取消。<br>
        (六)訂閱制以月為單位結算費用，若消費者於月底訂閱，仍會以該月整月之訂閱費用計費，消費者將於次月 1 日收到提醒繳費相關訊息之通知。
      </p>
      <p class="mt-1 mb-8">
        六、退貨/退款/取消訂閱機制<br>
        消費者有 14 天鑑賞期，鑑賞期自交易當日起算，並以提出退貨申請當日判斷是否超過 14 天鑑賞期。以下根據「產品」交易模式分別說明：<br>
        (一)買斷制：若於帳單結算前退貨，且退貨時未滿 14 天鑑賞期，則交易取消，不涉及退款。若於帳單結算後退貨，且退貨時未滿 14 天鑑賞期，則同意退貨，交易金額將全額退還。若退貨時已超過 14天鑑賞期，將拒絕退貨及退款申請。<br>
        (二)計時/計次收費：若於帳單結算前退貨，且退貨時未滿 14 天鑑賞期，則交易取消，不涉及退款行為。若於帳單結算後退貨，且退貨時未滿 14 天鑑賞期，則同意退貨，交易金額將全額退還。若退貨時已超過 14 天鑑賞期，則將拒絕退貨及退款申請。<br>
        (三)訂閱制：若於帳單結算前取消訂閱，且退貨時未滿 14 天鑑賞期，則同意退訂，次月 1 號不會產生訂單，故不涉及退款行為。若於帳單結算前取消訂閱，且退貨時超過 14 天鑑賞期，則「本平台」店家將辦理取消訂閱，但次月 1 號仍會產生訂單，消費者仍須繳費。若於帳單結算後取消訂閱，且取消訂閱時未滿 14 天鑑賞期，則同意退訂，交易金額將全額退還。若於帳單結算後取消訂閱，且取消訂閱時超過 14 天鑑賞期，則「本平台」店家將辦理取消訂閱，但消費者仍須繳納費用。
      </p>
      <p class="mt-1 mb-8">
        七、其他注意事項<br>
        消費者了解並同意「產品」之瑕疵擔保及保固均由「本平台」店家負擔，「本平台」、「本平台」營運單位(指工研院)、及第三方金流處理機構均不負任何瑕疵擔保責任。
      </p>
      <h3>陸、一般條款</h3>
      <p class="mt-1 mb-8">
        一、本服務條款中，如有任何條款之全部或一部無效時，不影響其他條款之效力。
      </p>
      <p class="mt-1 mb-8">
        二、「本平台」對本服務條款之適用保有最終解釋之權利。
      </p>
      <p class="mt-1 mb-8">
        三、因本服務條款所涉範圍之爭議與糾紛，以中華民國法律為準據法，並以台灣新竹地方法院為第一審管轄法院。
      </p>
    </div>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="_blue" outlined text @click="$emit('close')">{{$t("disagree")}}</v-btn>
      <v-btn class="_blue white--text" @click="$emit('agree')">{{$t("agree")}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {};
</script>

<style>
.close-button {
  cursor: pointer;
  position: absolute;
  right: 4px;
  top: 4px;
  padding: 8px;
}
</style>
